import React, {useEffect} from 'react';
import { useLocation } from 'react-router';
import icon from './assets/logo/logo510.ico';
import MainRoutes from './router/MainRoutes';
import NavBar from './components/common/NavBar';
import Footer from './components/common/footer/Footer';
import './App.css';

function App() {

  const currentPath = useLocation()
  const {pathname} = useLocation()
  console.log("La route courante ",{currentPath, pathname})

  useEffect(
      () => {
        window.scrollTo(
          {
            top:0,
            left:0,
            behavior: "smooth"
          }
        )
      }, [pathname]
    )

  return (
    
    <div >
      {/** Nav barre */}
              <NavBar navBarInfo={{
                  navLogo: 'Get-Conseil',
                  icon: icon,
                  links: [
                      'Home',
                      'careers',
                      'portfolio',
                      'Contact',
                      'About',
                      'Services'
                  ]
              }} />
      <MainRoutes />
      <Footer />
    </div>
  );
}

export default App;
